import AdminCrudPage from '../../components/AdminCrudPage/AdminCrudPage';
import { getAdminSection } from '../../admin/adminSections';
import { getAdminCrudConfig } from '../../admin/adminCrudConfig';

export default function CouponsPage() {
  const section = getAdminSection('coupons');
  const config = getAdminCrudConfig('coupons');

  return (
    <AdminCrudPage
      label={section.label}
      singular={config.singular}
      description={config.description}
      note={config.note}
      stats={section.stats}
      fields={config.fields}
      initialItems={config.initialItems}
    />
  );
}
